import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-select-item',
  imports: [],
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.scss'],
})
export class SelectItemComponent implements AfterViewInit {
  @Input() value?: string | number;
  @Input() hidden?: boolean;
  @ViewChild('item') item?: ElementRef;
  public content?: string;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.content = this.item?.nativeElement.innerHTML;
    });
  }
}
